import CustomModal from "../Customs/CustomModal";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import * as Yup from "yup";
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { Box, IconButton, Tooltip } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import axios from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Link, useNavigate } from "react-router-dom";
import { ErrorMessage, Field, Form, Formik } from "formik";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { useMessage } from "../MessageProvider/MessageProvider";
import Loading from "../Loading/Loading";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];
export default function FxModalProductEdit({
  openProductEdit,
  setOpenProductEdit,
  personBy,
  editableProduct,
  setEditAbleProduct,
  person,
  getSinglePerson,
}) {
  let navigate = useNavigate();
  let [product, setProduct] = React.useState(null);
  let [loading, setLoading] = React.useState(null);
  const messageApi = useMessage();
  let [names, setNames] = React.useState(false);
  let [products, setProducts] = React.useState({
    qop: editableProduct?.qop,
    from_to: editableProduct?.from_to,
    name: editableProduct?.name,
  });
  React.useEffect(() => {
    console.log(
      "https://calmness28.jprq.app/api/products/" + editableProduct?.id
    );
    console.log(editableProduct);
    console.log("personBy");
    console.log(personBy);
    setProducts({
      qop: editableProduct?.qop,
      from_to: editableProduct?.from_to,
      name: editableProduct?.name,
    });
  }, [editableProduct]);

  const handleEdit = async (values) => {
    try {
      setLoading(true);
      let token = localStorage.getItem("token");
      if (products.qop < 0 || products.qop == 0) {
        messageApi.open({
          type: "warning",
          content: "Qop noldan katta bolishi kerak",
        });
        return;
      }
      messageApi.open({
        type: "warning",
        content: "Yuklanmoqda",
      });

      let res = await axios.put(
        "https://calmness28.jprq.app/api/products/" + editableProduct?.id,
        {
          ...products,
          auto_number: values.auto_number,
          comment: values.comment,
          date: values.date,
          given_by: values.given_by,
          status: values.status,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      console.log(res);

      // navigate("/fx");
      if (res.data.success) {
        await getSinglePerson();
        setOpenProductEdit(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getNames = async () => {
    try {
      setLoading(true);

      let token = localStorage.getItem("token");
      console.log(token);
      let info = await axios.get(
        process.env.REACT_APP_API_URL + "/api/products/names",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(info.data);
      if (info.data.success) {
        setNames(info.data.names);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getNames();
  }, []);
  return (
    <CustomModal openModal={openProductEdit}>
      {loading ? <Loading /> : <></>}
      <div className=" w-[98%] py-[10px] my-0 m-auto">
        <div className="w-[100%] flex flex-row items-center justify-between">
          <button
            className="p-4"
            onClick={() => {
              setEditAbleProduct(null);
              setProducts(null);
              setOpenProductEdit(false);
            }}
          >
            <ClearOutlinedIcon />
          </button>
        </div>
        <h1 class="text-2xl font-bold mb-4 text-center">{personBy.name}</h1>
      </div>

      {editableProduct ? (
        <div className="max-w-[900px] mb-[40px] w-[98%] py-[10px] my-0 m-auto">
          <div className="flex flex-col md:flex-row flex-wrap items-center justify-start gap-[10px] w-[100%]">
            {products ? (
              <div className="bg-[#fff] p-4 shadow my-2 rounded w-[100%]  ">
                <div class="w-[100%]">
                  <label
                    for="options"
                    class="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Dori tanlang
                  </label>
                  <div class="relative">
                    <select
                      id="options"
                      value={products.name}
                      onChange={(e) => {
                        setProducts({
                          ...products,
                          name: e.target.value,
                        });
                      }}
                      class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="">Dori turi</option>
                      {names
                        ? names.map((el) => {
                            return <option value={el}>{el}</option>;
                          })
                        : null}
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M7 10l5 5 5-5H7z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row w-[100%] gap-1 justify-between">
                  <div class=" w-[100%] md:w-[50%]">
                    <label
                      for="input-with-helper-text"
                      class="block text-sm font-medium text-gray-700"
                    >
                      Necha qop
                    </label>
                    <input
                      type="number"
                      value={products.qop}
                      onChange={(e) => {
                        setProducts({
                          ...products,
                          qop:
                            e.target.value == "" ? "" : Number(e.target.value),
                        });
                      }}
                      id="input-with-helper-text"
                      class="w-[100%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder=" Necha qop"
                    />
                  </div>
                  <div class="w-[100%] md:w-[50%]">
                    <label
                      for="options"
                      class="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Qayerdan
                    </label>
                    <div class="relative">
                      <select
                        id="options"
                        value={products.from_to}
                        onChange={(e) => {
                          setProducts({
                            ...products,
                            from_to: e.target.value,
                          });
                        }}
                        class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="">Qayerdan</option>
                        <option value="Paxta zavod">Paxta zavod</option>
                        <option value="Ko'mirxona">Ko'mirxona</option>
                        <option value="Vagon">Vagon</option>
                      </select>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M7 10l5 5 5-5H7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
            <br />
          </div>

          {/* main form */}
          <Formik
            initialValues={{
              auto_number: editableProduct?.auto_number,
              status: editableProduct?.status,
              date: editableProduct?.date,
              given_by: editableProduct.given_by,
              comment: editableProduct.comment,
            }}
            validationSchema={Yup.object({
              given_by: Yup.string().required("Yozish shart"),
              date: Yup.string().required("Yozish shart"),

              auto_number: Yup.string().required("Yozish shart"),
              status: Yup.string().required("tanlanishi shart"),
            })}
            onSubmit={(values, { setSubmitting }) => {
              handleEdit(values);
            }}
          >
            <Form>
              <br />
              {/* Auto raqam */}
              <label htmlFor="auto_number">Auto raqam</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="auto_number"
                type="text"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="auto_number" />
              </div>
              <br />
              {/* date */}
              <label htmlFor="date">Sana</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="date"
                type="date"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="date" />
              </div>
              <br />

              {/* status */}
              <label htmlFor="status">status</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="status"
                as="select"
              >
                <option value="">Statusni tanlang</option>
                <option value="Nasiya">Nasiy</option>
                <option value="Bergan">Bergan</option>
                <option value="Birja">Birja</option>
                <option value="Birjadan yutadi">birjadan yutadi</option>
              </Field>
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="status" />
              </div>
              <br />
              {/* given_by */}
              <label htmlFor="given_by">Beribyuborgan shaxs</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="given_by"
                type="text"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="given_by" />
              </div>
              <br />
              {/* comment */}
              <label htmlFor="comment">Izox</label>
              <Field
                className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                name="comment"
                as="textarea"
                rows="4"
              />
              <div className="mt-1 text-sm text-red-600">
                <ErrorMessage name="comment" />
              </div>
              <br />
              <br />
              <button
                type="submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block w-full"
              >
                O'zgartirish
              </button>
            </Form>
          </Formik>
        </div>
      ) : (
        <></>
      )}
      {/* edit */}
    </CustomModal>
  );
}
